<template>
  <div class="rlil">
    <div class="tab-detail">
      <div class="infos">
        <div class="item-infos">
          <div class="info-holder" v-if="info">
            <div class="info-column">
              <div class="info-section">
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.type') }}:</span>
                  <span>{{ info.itemName }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.item-no') }}:</span>
                  <span>{{ info.itemNo }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.serial-no') }}:</span>
                  <span>{{ info.serialNo }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.pa-no') }}:</span>
                  <span>{{ info.paNo }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.cable-length') }}:</span>
                  <span v-if="info.cableLength">{{ info.cableLength }} m</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.connector1') }}:</span>
                  <span>{{ info.connector1 }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.connector2') }}:</span>
                  <span>{{ info.connector2 }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.cable') }}:</span>
                  <span>{{ info.cableType }}</span>
                </div>
              </div>
            </div>
            <div class="info-column">
              <div class="info-section">
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.date') }}:</span>
                  <span>{{ info.testDate }}</span>
                </div>
              </div>
              <div class="info-section">
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.start-frequency') }}:</span>
                  <span>{{ info.startFreq }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.stop-frequency') }}:</span>
                  <span>{{ info.stopFreq }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.measure-points') }}:</span>
                  <span>{{ info.measurePoints }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.source-power') }}:</span>
                  <span>{{ info.sourcePower }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <chart-overview :articleNo="articleNo" :serialNo="serialNo" class="full-width" />
      <div class="charts full-width">
        <Chart v-if="(labelsIlFwd && dataPointsIlFwd)" :label="$t('hs.att-dashboard.item-value')" :title="s21Text" :labels="labelsIlFwd" :data-points="dataPointsIlFwd"
               :secondary-data-points="secondaryDataPointsIlFwd" :secondary-label="$t('hs.att-dashboard.item-limit')"
               x-label="GHz" y-label="dB"
        />
        <Chart v-if="(labelsRlFwd && dataPointsRlFwd)" :label="$t('hs.att-dashboard.item-value')" :title="s11Text" :labels="labelsRlFwd" :data-points="dataPointsRlFwd"
               :secondary-data-points="secondaryDataPointsRlFwd" :secondary-label="$t('hs.att-dashboard.item-limit')"
               x-label="GHz" y-label="dB"
        />
        <Chart v-if="(labelsIlRev && dataPointsIlRev)" :label="$t('hs.att-dashboard.item-value')" :title="s12Text" :labels="labelsIlRev" :data-points="dataPointsIlRev"
               :secondary-data-points="secondaryDataPointsIlRev" :secondary-label="$t('hs.att-dashboard.item-limit')"
               x-label="GHz" y-label="dB"
        />
        <Chart v-if="(labelsRlRev && dataPointsRlRev)" :label="$t('hs.att-dashboard.item-value')" :title="s22Text" :labels="labelsRlRev" :data-points="dataPointsRlRev"
               :secondary-data-points="secondaryDataPointsRlRev" :secondary-label="$t('hs.att-dashboard.item-limit')"
               x-label="GHz" y-label="dB"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { getResponseFromEntryPoint, createInfoServiceParams, linkEntryPoints } from '@/rest/restClient.js'
  import Chart from '@/components/charts/item-chart'
  import ChartOverview from '@/components/rl-il/chart-overview'

  export default {
    name: 'rl-il',
    props: {
      articleNo: {
        type: String,
        required: true
      },
      serialNo: {
        type: String,
        required: true
      }
    },
    components: {
      ChartOverview,
      Chart
    },
    data () {
      return {
        infoResponse: null,
        labelsRlFwd: null,
        dataPointsRlFwd: null,
        secondaryDataPointsRlFwd: null,
        ilFwdFail: true,
        labelsRlRev: null,
        dataPointsRlRev: null,
        secondaryDataPointsRlRev: null,
        rlFwdFail: true,
        labelsIlFwd: null,
        dataPointsIlFwd: null,
        secondaryDataPointsIlFwd: null,
        ilRevFail: true,
        labelsIlRev: null,
        dataPointsIlRev: null,
        secondaryDataPointsIlRev: null,
        rlRevFail: true
      }
    },
    methods: {
      async fetchData () {
        const params = createInfoServiceParams(this.articleNo, this.serialNo)

        const result = await getResponseFromEntryPoint(linkEntryPoints.infoService, params)
        if (!result.error) {
          this.infoResponse = result
          this.$emit('success:api', result)
        } else {
          this.infoResponse = null
          this.$emit('error:api', result.error)
        }

        let datailFwdChartService = await getResponseFromEntryPoint(linkEntryPoints.ilFwdChartService, params)
        if (!datailFwdChartService.error) {
          datailFwdChartService = datailFwdChartService.props
          this.labelsIlFwd = datailFwdChartService.xAxis
          this.dataPointsIlFwd = datailFwdChartService.yAxis
          this.secondaryDataPointsIlFwd = datailFwdChartService.itemChartLimits
          this.ilFwdFail = datailFwdChartService.fail
        } else {
          this.labelsIlFwd = null
          this.dataPointsIlFwd = null
          this.secondaryDataPointsIlFwd = null
          this.ilFwdFail = null
        }

        let datarlFwdChartService = await getResponseFromEntryPoint(linkEntryPoints.rlFwdChartService, params)
        if (!datarlFwdChartService.error) {
          datarlFwdChartService = datarlFwdChartService.props
          this.labelsRlFwd = datarlFwdChartService.xAxis
          this.dataPointsRlFwd = datarlFwdChartService.yAxis
          this.secondaryDataPointsRlFwd = datarlFwdChartService.itemChartLimits
          this.rlFwdFail = datarlFwdChartService.fail
        } else {
          this.labelsRlFwd = null
          this.dataPointsRlFwd = null
          this.secondaryDataPointsRlFwd = null
          this.rlFwdFail = null
        }

        let datailRevChartService = await getResponseFromEntryPoint(linkEntryPoints.ilRevChartService, params)
        if (!datailRevChartService.error) {
          datailRevChartService = datailRevChartService.props
          this.labelsIlRev = datailRevChartService.xAxis
          this.dataPointsIlRev = datailRevChartService.yAxis
          this.secondaryDataPointsIlRev = datailRevChartService.itemChartLimits
          this.ilRevFail = datailRevChartService.fail
        } else {
          this.labelsIlRev = null
          this.dataPointsIlRev = null
          this.secondaryDataPointsIlRev = null
          this.ilRevFail = null
        }

        let datarlRevChartService = await getResponseFromEntryPoint(linkEntryPoints.rlRevChartService, params)
        if (!datarlRevChartService.error) {
          datarlRevChartService = datarlRevChartService.props
          this.labelsRlRev = datarlRevChartService.xAxis
          this.dataPointsRlRev = datarlRevChartService.yAxis
          this.secondaryDataPointsRlRev = datarlRevChartService.itemChartLimits
          this.rlRevFail = datarlRevChartService.fail
        } else {
          this.labelsRlRev = null
          this.dataPointsRlRev = null
          this.secondaryDataPointsRlRev = null
          this.rlRevFail = null
        }
      }
    },
    computed: {
      s21Text () {
        return `S21 (IL Fwd) ${this.ilFwdFail ? 'FAIL' : 'PASS'}`
      },
      s11Text () {
        return `S11 (RL Fwd) ${this.rlFwdFail ? 'FAIL' : 'PASS'}`
      },
      s12Text () {
        return `S12 (IL Rev) ${this.ilRevFail ? 'FAIL' : 'PASS'}`
      },
      s22Text () {
        return `S22 (RL Rev) ${this.rlRevFail ? 'FAIL' : 'PASS'}`
      },
      info () {
        return this.infoResponse ? this.infoResponse.props : null
      }
    },
    created () {
      if (this.articleNo && this.serialNo) {
        this.fetchData()
      }
      this.$watch(vm => [vm.articleNo, vm.serialNo].join(), this.fetchData)
    }
  }
</script>

<style lang="scss" scoped>
  .charts {
    display: flex;
    flex-wrap: wrap;
  }

  .full-width {
    width: 100%;
  }

  .info-holder {
    display: flex;
    justify-content: space-between;
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .chart,
  .item-infos {
    width: 100%;
  }

  .tab-detail {
    display: flex;
    flex-direction: column;
  }

  .infos {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: $component-padding;
  }

  .info-column {
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .label {
    min-width: 50%;
    font-weight: bold;
  }

  .label-value-entry {
    display: flex;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .info-holder {
    flex-direction: column;
  }

  @media only screen and (min-width: $screen-sm-min) {
    .info-holder {
      flex-direction: row;
    }

    .full-width {
      width: calc((100% + 1rem) / 2 * 3);
    }
  }

  @media only screen and (min-width: $screen-md-min) {
    .full-width {
      width: calc((100% + 1rem) / 3 * 4);
    }

    .chart {
      width: 50%;
    }
  }
</style>
